export class LicenseType {
    licenseTypeId: string;
    name: string;
    datesRequired?: boolean;
}
